<section class="container-style">
  <form [formGroup]="formReverse">
    <div class="row">
      <div class="col-lg-12 col-md-12 col-sm-12 col-12 fw-bold mb-1">
        <label>Para revertir el proceso de importación de Saldos Alquiler, seleccione la Compañía y Sucursal:</label>
      </div>
      <div class="col-lg-12 col-md-12 col-sm-12 col-12">
        <app-custom-autocomplete formControlName="companyId" [labelText]="'Companía'" [list]="listCompanies"
          [required]="true" [recovery]="true" (onChangeSelect)="getCompany($event)">
        </app-custom-autocomplete>
      </div>
      <div class="col-lg-12 col-md-12 col-sm-12 col-12">
        <app-custom-select formControlName="branchId" [labelText]="'Sucursal'" [list]="listBranches" [required]="true"
          [recovery]="true" (onChangeSelect)="getBranch($event)">
        </app-custom-select>
      </div>
      <div class="col-lg-12 col-md-12 col-sm-12 col-12 d-flex justify-content-end align-items-end mt-md-3">
        <app-custom-button [label]="'Revertir'" [severity]="'primary'" [variant]="undefined"
          (onClick)="reverseRentalBalance()"></app-custom-button>
      </div>
    </div>
  </form>
</section>